import { ChecklistRepository } from "../../repositories/ChecklistRepository";

/**
 * Mark Item Done Use Case
 * Marks a checklist item as done
 */
export class MarkItemDoneUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(itemId: number, notes?: string, description?: string): Promise<void> {
    return await this.repository.markItemDone(itemId, notes, description);
  }
}

